import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import { IlotInfosPage } from '@fields/feature';

const searchSchema = z.object({
  ilotId: z.coerce.number().int().positive(),
  pointId: z.coerce.number().int().positive().optional(),
  pointCode: z.string().optional(),
  sampleId: z.coerce.number().int().positive().optional(),
  lng: z.coerce.number().optional(),
  lat: z.coerce.number().optional(),
  zoom: z.coerce.number().optional(),
  scope: z.enum(['personal', 'organization']).optional(),
});

export const Route = createFileRoute('/_app/map-infos')({
  validateSearch: zodSearchValidator(searchSchema),
  component: IlotInfosPage,
});
